import { ICON } from '../../config/icons';
import './ToggleWithIcon.scss';

interface ToggleWithIconProps {
  label: string;
  icon: (typeof ICON)[keyof typeof ICON];
  iconOff?: (typeof ICON)[keyof typeof ICON];
  onToggle: (checked: boolean) => void;
  isToggled: boolean;
  isReadOnly?: boolean;
}

export const ToggleWithIcon = ({
  label,
  icon,
  iconOff,
  onToggle,
  isToggled,
  isReadOnly = false,
}: ToggleWithIconProps) => {
  const handleToggle = (checked: boolean) => {
    onToggle(checked);
  };

  // TODO: wire up off icon
  const renderIcon = () => {
    if (typeof icon === 'string') {
      return (
        <div className="toggle-with-icon--icon">
          <img src={icon} alt={`${label} icon`} className="toggle-with-icon--icon-image" />
        </div>
      );
    }
    return <></>;
  };
  return (
    <div
      className={`toggle-with-icon ${isToggled ? 'toggled' : ''} ${isReadOnly ? 'read-only' : ''}`}
    >
      <div className="toggle-with-icon--container">
        <div className="toggle-with-icon--label">
          {renderIcon()} <span>{label}</span>
        </div>
        {/* <button
          className={`toggle-with-icon--button ${isToggled ? 'toggled' : ''}`}
          onClick={onToggle}
        >
          {isToggled ? 'On' : 'Off'}
        </button> */}
        <div className="toggle-with-icon--switch">
          <label className="switch">
            <input
              type="checkbox"
              className="checkbox"
              checked={isToggled ?? false}
              onChange={(e) => handleToggle(e.target.checked)}
              disabled={isReadOnly}
            />
            <span className="slider"></span>
          </label>
        </div>
      </div>
    </div>
  );
};

{
  /* <label htmlFor="toggle-lock" className="switch">
  <input
    type="checkbox"
    id="toggle-lock"
    className="checkbox"
    checked={currentLock === true ? true : false}
    onChange={(e) => handleLock(e.target.checked)}
    disabled={isReadOnly}
  />
  <span className="slider"></span>
</label>; */
}
